import { Service } from '@timing71/common';
import { Client } from './client.js';
import { getManifest, getState } from './translate.js';

export class TSL extends Service {

  start(connectionService) {
    super.start(connectionService);

    const match = this.service.source.match(TSL.regex);
    const eventID = match.groups.eventID;

    this.client = new Client(eventID, connectionService);

    this.client.on('update', s => this.onStateChange(getState(s)));

    this.client.on('sessionChange', s => this.onManifestChange(getManifest(s)));

    this.client.on('raceControlMessage', (m) => this.onStateChange({ extraMessages: [m] }));

    this.client.start();
  }

  stop() {
    this.client.stop();
  }

}

TSL.regex = /(livetiming|www).tsl-timing.com\/(event\/)?(?<eventID>[0-9]+)$/;
